module.exports = __webpack_public_path__ + "images/alert-bell-black-ab234ba2.svg";